import { NavLink, Outlet } from "react-router-dom";
import {
  BookOpenText,
  ClipboardList,
  FileText,
  History,
  LayoutDashboard,
  ListTree,
  Receipt,
  Scale,
  Settings as SettingsIcon,
} from "lucide-react";

import { cn } from "@/lib/utils";

interface NavTab {
  to: string;
  label: string;
  icon: typeof LayoutDashboard;
  end?: boolean;
}

const TABS: NavTab[] = [
  { to: "/general-ledger", label: "Overview", icon: LayoutDashboard, end: true },
  { to: "/general-ledger/accounts", label: "Chart of Accounts", icon: ListTree },
  { to: "/general-ledger/journals", label: "Journals", icon: FileText },
  {
    to: "/general-ledger/reports/trial-balance",
    label: "Trial Balance",
    icon: Scale,
  },
  {
    to: "/general-ledger/reports/ledger",
    label: "Ledger",
    icon: ClipboardList,
  },
  {
    to: "/general-ledger/reports/statements",
    label: "Statements",
    icon: Receipt,
  },
  { to: "/general-ledger/periods", label: "Periods", icon: SettingsIcon },
  { to: "/general-ledger/audit", label: "Audit", icon: History },
];

export default function GeneralLedgerShell() {
  return (
    <div className="space-y-6 max-w-[1400px]">
      <div className="flex items-start gap-3">
        <div className="h-12 w-12 rounded-xl bg-primary/10 text-primary flex items-center justify-center shrink-0">
          <BookOpenText className="h-6 w-6" />
        </div>
        <div className="min-w-0">
          <h1 className="text-3xl font-bold tracking-tight">General Ledger</h1>
          <p className="text-muted-foreground max-w-3xl">
            Double-entry accounting: maintain the chart of accounts, post and
            reverse journal entries, reconcile, close periods, and run trial
            balance and financial statements.
          </p>
        </div>
      </div>

      <nav className="flex flex-wrap gap-1 rounded-lg border bg-card p-1 shadow-card">
        {TABS.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            end={tab.end}
            className={({ isActive }) =>
              cn(
                "inline-flex items-center gap-2 rounded-md px-3 py-1.5 text-sm font-medium transition-colors",
                isActive
                  ? "bg-primary text-primary-foreground shadow-card"
                  : "text-muted-foreground hover:bg-muted hover:text-foreground",
              )
            }
          >
            <tab.icon className="h-4 w-4" />
            {tab.label}
          </NavLink>
        ))}
      </nav>

      <Outlet />
    </div>
  );
}
